import React, { useState } from 'react'
import { Button, Box, Div, H2, P, ListGrid, ListGridItem, Icon, MotivationsIcon } from '@maui/elements'
import CopyToClipboard from 'react-copy-to-clipboard'
import { commaFormatted } from '../../../../utilities/commaFormatted'

const IndicatorTotal = ({ indicators }) => {
  if (!indicators) return null
  const indicatorsTotal = indicators.count.total
  const indicatorsCount = indicatorsTotal > 1 ? `${commaFormatted(indicatorsTotal)} Indicators` : `${commaFormatted(indicatorsTotal)} Indicator`
  return (
    <Div textStyle='sectionLabel1' letterSpacing='1px' textTransform='uppercase' color='colorTextDeemphasis'>
      {indicatorsCount}
    </Div>
  )
}

export const SearchPreviewHeader = ({ icon, name, indicators }) => {
  return (
    <Box display='flex'>
      <Box p='20px'>
        {icon}
      </Box>
      <Box pt='12px' pb='16px'>
        <H2 m={0}>{name}</H2>
        {indicators && <IndicatorTotal indicators={indicators}/>}
      </Box>
    </Box>
  )
}

export const ShowMoreDescription = ({ description = '' }) => {
  const [showMore, setShowMore] = useState(true)
  if (!description) return null
  return (
    <>
      <P
        m={0}
        lineHeight='20px'
        style={{
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: showMore ? '3' : '20',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'normal',
          display: '-webkit-box',
        }}
      >
        {description}
      </P>
      {
        description.length > 250 && (
          <Box pt='16px'>
            <Button
              variant='text'
              fontSize='10px'
              fontWeight={700}
              lineHeight='16px'
              letterSpacing='2px'
              padding='0px'
              onClick={() => setShowMore(!showMore)}
              textTransform='uppercase'
            >
              {showMore ? 'Show More' : 'Show Less'}
            </Button>
          </Box>
        )
      }
    </>
  )
}

const iconsMap = {
  linux: 'linux-logo',
  mac: 'apple-logo',
  windows: 'windows-logo'
}

export const SearchPreviewListGrid = ({ title, list, cellWidth }) => (
  <Box display='flex' flexDirection='row' marginBottom='10px'>
    <Box width='25%'>
      <Box fontSize='12px' fontWeight={400} lineHeight='16px' color='colorTextDeemphasis'>
        {title}
      </Box>
    </Box>
    <Box width='75%'>
      <ListGrid list={list} cellWidth={cellWidth}>
        {(item) => (
          <ListGridItem>
            {title === 'Motivations' &&
              <MotivationsIcon
                name={item.name}
              />
            }
            {title === 'Operating Systems' &&
              <Icon name={iconsMap[item.toLowerCase()]} />
            }
            <Box fontSize='12px' fontWeight={700} lineHeight='18px'>
              {item.name || item}
            </Box>
          </ListGridItem>
        )}
      </ListGrid>
    </Box>
  </Box>
)

export const CopyButton = ({ value }) => (
  <CopyToClipboard text={value}>
    <Box cursor='pointer' title={value}>
      <Icon name='copy-clipboard' color='colorActionPrimary' />
    </Box>
  </CopyToClipboard>
)
